import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { DocentTimetableEntryDTO } from '../models/docent-timetable-entry.model';

@Injectable({
  providedIn: 'root',
})
export class DocentTimetableService {
  private readonly apiUrl = environment.apiUrl + '/teamsmeeting/docent';

  constructor(private readonly httpClient: HttpClient) {}

  /**
   * @param from,to DateOnly, z.B. "2026-01-01".
   * @param docentName Ohne Angabe der Plan des Aufrufers; ein fremder Name erfordert
   * Meeting.Write bzw. Users.Read, sonst 403.
   */
  getTimetable(
    from: string,
    to: string,
    docentName?: string | null,
  ): Observable<DocentTimetableEntryDTO[]> {
    let params = new HttpParams().set('from', from).set('to', to);
    if (docentName) {
      params = params.set('docentName', docentName);
    }

    return this.httpClient.get<DocentTimetableEntryDTO[]>(
      `${this.apiUrl}/timetable`,
      { params },
    );
  }
}
